export default {
  setAtivo(state, payload) {
    state.ativo = payload;
  },
  setProdutos(state, payload) {
    state.produtos = payload;
  },
  setItens(state, payload) {
    state.itens = payload;
  },
  setParcelas(state, payload) {
    state.parcelas = payload;
  },
  setAllFormParcelas(state, payload) {
    state.form.parcelas = payload;
  },
  setForm(state, payload) {
    if (payload.tempo) state.form.tempo = parseFloat(payload.tempo);
    if (payload.diautil) state.form.diautil = parseFloat(payload.diautil);
  },
  setFormParcela(state, payload) {
    state.form.parcela = payload;
  },
  setCalcular(state, payload) {
    state.itens.push(payload);
  },
  setParcela(state, payload) {
    state.parcelas.push(payload);
  },
  setDisable(state, payload) {
    state.produtos.forEach(p => {
      p.disabled = true;
    });

    state.produtos.forEach(pro => {
      payload.forEach(pay => {
        if (pro.idproduto == pay.idproduto) {
          pro.disabled = false;
        }
      });
    });
  }
};
